import { useRouter } from "next/router";

export const useRouterPush = () => {
  const router = useRouter();
  return async (url: string) => {
    return router.push(url);
  };
};
